module.exports = __webpack_public_path__ + "label-clustered.de73a244.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/label-clustered.svg
// module id = iZFd
// module chunks = 0